import { useQuery } from '@tanstack/react-query';
import { fetchProcessesForCycle } from '../../request/sox';
import { fetchFlowchartVersions } from '../../request/flowchart';
import { flowchartVersionsQueryKey } from '../../queries/flowchart';
import { processesQueryKey } from '../../queries/sox';

export function useFlowchartQueries({ cycleId, processId }) {
  const { data: allProcesses = [] } = useQuery({
    queryKey: processesQueryKey(cycleId),
    queryFn: () => fetchProcessesForCycle(cycleId),
    enabled: Boolean(cycleId)
  });

  const {
    data: versionOptions = [],
    refetch: refetchVersionOptions
  } = useQuery({
    queryKey: flowchartVersionsQueryKey(cycleId, processId),
    queryFn: () => fetchFlowchartVersions(cycleId, processId),
    enabled: Boolean(cycleId && processId)
  });

  return {
    allProcesses,
    versionOptions,
    refetchVersionOptions
  };
}
